<template>
	<div>
		<van-nav-bar class="userNavBar" @click-left="onClickLeft" title="用户使用协议" left-arrow>
			<template #left>
				<van-icon name="../../../static/images/mobile/back.png" size="18" />
			</template>
		</van-nav-bar>
		<div class="center agreementtitle">使用协议和注册协议</div>
		<div class="title1">一、接受协议</div>
		<div class="contents">
			1、一旦您注册成为职业技能培训平台PC端的用户，便表示您（以下简称“用户”）已经完全理解并同意接受本协议（以下简称“协议”）。职业技能培训平台PC端可随时自行全权决定更改“协议”。如用户不同意相关变更，则必须停止使用“我们的服务”；如果用户继续使用“我们的服务”，则表示已无条件接受经修订的“协议”。除另行明确声明外，任何使我们的“服务内容”范围扩大或功能增强的新内容均受本协议约束。
		</div>
		<div class="title1">二、服务内容</div>
		<div class="contents">1、除非另有明确规定，增强或强化职业技能培训平台PC端目前服务的任何新功能，包括新产品以及新增加的服务，均无条件地适用本协议.</div>
		<div class="contents">
			2、职业技能培训平台PC端向广大用户提供免费和收费的网络服务产品，用户使用免费网络服务不必向职业技能培训平台PC端支付任何费用。对于收费的网络服务，职业技能培训平台PC端在用户使用之前给予用户明确的提示，只有用户根据提示确认其愿意支付相关费用后，用户才能使用该等收费网络服务。如用户拒绝支付相关费用，则职业技能培训平台PC端有权不向用户提供该等收费网络服务。
		</div>
		<div class="contents">
			3、用户自行负担使用职业技能培训平台PC端服务所需的相关设备（如个人电脑及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的上网费、为使用移动网而支付的手机费）。
		</div>
		<div class="title1">三、用户使用规则</div>
		<div class="contents">
			1、用户有责任维持注册的账号和密码的安全，用户应对所有用本人的密码及帐号的活动负完全的责任。用户同意∶(a)
			本人的密码或帐号遭到未获授权的使用，或者发生其它任何安全问题时，将立即通知职业技能培训平台PC端；且(b)每次上网完毕都会把本人的帐号关掉。如未能依前述规定行事，对于任何人利用该密码及帐号所进行的任何行为，用户应负完全的责任。对于因此而产生的任何损失或损害，职业技能培训平台PC端无法也不承担任何责任。
			根据有关法律法规，职业技能培训平台PC端在此郑重提请用户注意，任何经由我们的服务以上载、张贴、发送电子邮件或任何其它方式传送的资讯、资料、文字、软件、音乐、音讯、照片、图形、视讯、信息或其它资料（以下简称“内容”），无论系公开还是私下传送，均由内容提供者、上传者承担责任。职业技能培训平台PC端有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用我们的服务的全部或部分，保存有关记录，并向有关机关报告
		</div>
		<div class="contents">
			2、用户在职业技能培训平台PC端发布信息（包括注册用户名）时，必须遵守国家有关法律规定，并承担一切因自己发布信息不当导致的民事、行政和/或刑事法律责任。用户在职业技能培训平台PC端所发布的信息（包括注册用户名、上传视频、发表日记、评论以及其他内容），不得含有以下任何内容：
			(1)违反宪法确定的基本原则的； (2)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的； (3)损害国家荣誉和利益，攻击党和政府的；
			(4)煽动民族仇恨、民族歧视，破坏民族团结的； (5)破坏国家、地区间友好关系的； (6)违背中华民族传统美德、社会公德、论理道德、以及社会主义精神文明的；
			(7)破坏国家宗教政策，宣扬邪教和封建迷信的； (8)散布谣言或不实消息，扰乱社会秩序 ，破坏社会稳定的；
			(9)煽动、组织、教唆恐怖活动、非法集会、结社、游行、示威、聚众扰乱社会秩序的； (10)散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
			(11)侮辱或诽谤他人，侵害他人合法权益的； (12)侵犯他人肖像权、姓名权、名誉权、隐私权或其他人身权利的；
			(13)使用漫骂、辱骂、中伤、恐吓、诅咒等不文明语言的； (14)以非法民间组织名义活动的； (15)侵犯他人著作权、信息网络传播权等合法权益的；
			(16)含有法律、行政法规禁止的其他内容的.
		</div>
		<div class="contents">
			3、如果用户在职业技能培训平台PC端发布信息时不能履行和遵守协议中的规定，为维护本产品的形象、信誉、安全，本产品有权删除用户发布的相关信息，并对违反协议的用户做出封闭ID和/或暂时、永久禁止在本产品发布信息的处理，同时保留依法追究当事人法律责任的权利。此外，本产品在采取移除等相应措施后不为此向原发布人承担违约责任或其他法律责任，包括不承担因侵权指控不成立而给原发布人带来损害的赔偿责任。
		</div>
		<div class="contents">
			4、用户需独立对自己在本产品上实施的行为承担法律责任。若用户的行为不符合本协议，职业技能培训平台PC端有权做出独立判断立即取消用户服务帐号。用户若在职业技能培训平台PC端上散布和传播反动、色情或其他违反国家法律的信息，职业技能培训平台PC端的系统记录有可能作为用户违反法律的证据。
		</div>
		<div class="contents">5、注册用户在使用职业技能培训平台PC端的各项服务的同时，有义务协助推广宣传职业技能培训平台PC端及其产品和服务。</div>
		<div class="contents">
			6、职业技能培训平台PC端不对用户所发布信息的删除或储存失败承担任何责任。职业技能培训平台PC端有权判定用户的行为是否符合中国法律法规的规定以及职业技能培训平台PC端服务条款的要求，如果用户违背了中国法律法规的规定或服务条款的规定，职业技能培训平台PC端有中断对其提供服务的权利。对于用户通过职业技能培训平台PC端网络技术服务上传到职业技能培训平台PC端上可公开获取区域的任何内容即视为用户同意授予职业技能培训平台PC端所有上述内容的在全球范围内的免费、不可撤销的无限期的并且可转让的非独家使用权许可，职业技能培训平台PC端有权展示、散布及推广前述内容，有权对前述内容进行任何形式的复制、修改、出版、发行及以其他方式使用或者授权第三方进行复制、修改、出版、发行及以其他方式使用。
		</div>
		<div class="contents">7、对于以商业目的为核心的，向学员提供代学代考等私下交易的学员和个人，职业技能培训平台保留追究其法律责任的权利。</div>
		<div class="contents">
			8、对于因代学代考或职业技能培训平台以外的私下交易等原因造成的用户个人信息泄露和财务损失等问题，职业技能培训平台不承担任何责任。
		</div>
		<div class="title1">四、隐私保护</div>
		<div class="contents">
			1、职业技能培训平台PC端保证不对外公开或向第三方提供单个用户的注册资料及用户在使用网络服务时存储在职业技能培训平台PC端的非公开内容，但下列情况除外：
			（1）事先获得用户的明确授权； （2）根据有关的法律法规要求； （3） 按照相关政府主管部门的要求； （4）为维护社会公众的利益；
			（5）为职业技能培训平台PC端的合法权益； （6）其他需要公开、编辑或透露个人信息的情况。
		</div>
		<div class="contents">
			2、职业技能培训平台PC端可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与职业技能培训平台PC端同等的保护用户隐私的责任，则职业技能培训平台PC端有权将用户的注册资料等提供给该第三方。
		</div>
		<div class="contents">3、在不透露单个用户隐私资料的前提下，职业技能培训平台PC端有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。</div>
		<div class="title1">五、关于注册用户在职业技能培训平台PC端上传的作品和内容</div>
		<div class="contents">1、用户上传的作品和内容是指用户在本产品上载或发布的视频、音频或其它任何形式的内容包括文字、图片、链接等。</div>
		<div class="contents">2、用户在本产品上传或发布原创作品及转载作品的，用户保证其对该等作品享有合法著作权/版权或者相应授权。</div>
		<div class="contents">3、因用户进行上述作品和内容在本产品的上传或发布而导致任何第三方提出索赔要求或衍生的任何损害或损失，由用户承担全部责任.</div>
		<div class="title1">六、知识产权</div>
		<div class="contents">
			1、职业技能培训平台PC端提供的网络服务中包含的任何文本、图片、图形、音频和/或视频资料均受版权、商标和/或其它财产所有权法律的保护。未经相关权利人同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。所有这些资料或资料的任何部分仅可作为私人用途而保存在某台计算机内。职业技能培训平台PC端不就由上述资料产生或在传送或递交全部或部分上述资料过程中产生的延误、不准确、错误和遗漏或从中产生或由此产生的任何损害赔偿，以任何形式向用户或任何第三方负法律责任。
		</div>
		<div class="contents">
			2、职业技能培训平台PC端为提供网络服务而使用的任何软件（包括但不限于软件中所含的任何图象、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于该软件的著作权人，未经该软件的著作权人许可，用户不得对该软件进行反向工程（reverse
			engineer）、反向编译（decompile）或反汇编（disassemble）等。
		</div>
		<div class="title1">七、免责声明</div>
		<div class="contents">
			1、用户明确同意其使用职业技能培训平台PC端网络服务所存在的风险将完全由其本人承担；因其使用职业技能培训平台PC端网络服务而产生的一切后果也由其本人承担。职业技能培训平台PC端对用户及任何第三方不承担任何责任.
		</div>
		<div class="contents">
			2、职业技能培训平台PC端不担保或保证网络服务一定能满足用户的要求，也不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作任何担保或保证。
		</div>
		<div class="contents">
			3、职业技能培训平台PC端不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由职业技能培训平台PC端实际控制的任何网页上的内容，职业技能培训平台PC端也不承担任何责任。
		</div>
		<div class="contents">
			4、对于因不可抗力或职业技能培训平台PC端不能控制的原因造成的网络服务中断或其它缺陷，职业技能培训平台PC端不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。
		</div>
		<div class="contents">
			5、职业技能培训平台PC端对于任何自本产品而获得的他人的信息、内容或者广告宣传等任何资讯（以下统称“信息”），不保证真实、准确和完整性。如果任何单位或者个人通过上述“信息”而进行任何行为，须自行甄别真伪和谨慎预防风险。否则，无论何种原因，本产品不对任何非与本产品直接发生的交易和/或行为承担任何直接、间接、附带或衍生的损失和责任。
		</div>
		<div class="contents">
			6、用户同意，对于职业技能培训平台PC端向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，职业技能培训平台PC端无需承担任何责任： （1）
			职业技能培训平台PC端向用户免费提供的各项网络服务； （2） 职业技能培训平台PC端向用户赠送的任何产品或者服务； （3）
			职业技能培训平台PC端向收费网络服务用户附赠的各种产品或者服务； （4） 用户资料遭到未授权的使用或修改； （5） 其他与本产品相关的事宜.
		</div>
		<div class="title1">八、通知送达</div>
		<div class="contents">
			1、本协议项下职业技能培训平台PC端对于用户所有的通知均可通过网页公告、电子邮件、手机短信或其他常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。
		</div>
		<div class="contents">
			2、 用户对于职业技能培训平台PC端的通知应当通过职业技能培训平台PC端对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。
		</div>
		<div class="title1">九、责任限制</div>
		<div class="contents">
			用户明确了解并同意，基于以下原因造成的包括但不限于利润、信誉、应用、数据损失或其它无形损失，职业技能培训平台PC端不承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿责任（即使职业技能培训平台PC端事先已被告知发生此种赔偿之可能性亦然）：(i)我们的服务之使用或无法使用，(ii)为替换从或通过我们的服务购买或取得之任何商品、数据、信息、服务，收到的讯息，或缔结之交易而发生的成本，(iii)用户的传输或数据遭到未获授权的存取或变造，(iv)
			任何第三方在我们的服务中所作之声明或行为，或(v)与我们的服务相关的其它事宜，但本协议有明确规定的除外。
		</div>
		<div class="title1">十、服务的修改</div>
		<div class="contents">
			职业技能培训平台PC端有权于任何时间暂时或永久修改或终止我们的服务（或其任何部分），而无论其通知与否。用户同意对于我们的服务所作的任何修改、暂停或终止，职业技能培训平台PC端对用户和任何第三人均无需承担任何责任。
		</div>
		<div class="title1">十一、终止服务</div>
		<div class="contents">
			用户同意职业技能培训平台PC端有权基于其自行之考虑，因任何理由，包含但不限于缺乏使用或职业技能培训平台PC端认为用户已经违反本协议的文字及精神，而终止用户的密码、帐号或我们的服务之使用（或服务之任何部分），并将用户在我们的服务内的任何内容加以移除并删除。职业技能培训平台PC端亦得依其自行之考虑，于通知或未通知之情形下，随时终止我们的服务或其任何部分。用户同意依本协议任何规定提供之我们的服务，无需进行事先通知即可中断或终止，用户承认并同意，职业技能培训平台PC端可立即关闭或删除用户的帐号及用户帐号中所有相关信息及文件，及/或禁止继续使用前述文件或我们的服务。此外，用户同意若我们的服务之使用被中断或终止或用户的帐号及相关信息和文件被关闭或删除，职业技能培训平台PC端对用户或任何第三人均不承担任何责任。
		</div>
		<div class="title1">十二、法律管辖与适用</div>
		<div class="contents">1、本服务协议的生效、履行、解释及争议的解决均适用中华人民共和国法律。</div>
		<div class="contents">
			2、如就本协议内容或其执行发生任何争议，应尽量友好协商解决；协商不成时，则争议各方均可向职业技能培训平台PC端所在地的人民法院提起诉讼。
		</div>
		<div class="contents" style="padding-bottom: 1rem;">
			特别提示：用户在进行注册之前，请确保本人已经完全理解并接受本协议所有条款（尤其是免责条款），否则，请不要注册。一旦用户正式注册，则表明用户已经完全理解并接受本协议所有条款，尤其是免责和责任限制条款
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	methods: {
		onClickLeft() {
			this.$router.go(-1);
		},
	},
};
</script>

<style scoped>
.userNavBar {
	width: 100%;
	margin-top: 0.133333rem;
}
.center {
	text-align: center;
}
.title1 {
	margin-left: 0.426667rem;
	color: #000000;
	font-weight: bold;
	font-size: 0.373333rem;
	margin-bottom: 0.373333rem;
}
.contents {
	padding-left: 0.426667rem;
	padding-right: 0.426667rem;
	margin-bottom: 0.64rem;
}
.agreementtitle {
	margin-top: 0.64rem;
	margin-bottom: 0.8rem;
	color: #000000;
	font-weight: bold;
	font-size: 0.453333rem;
}

</style>


// WEBPACK FOOTER //
// MobileAgreement.vue?ca9e649e